import { Card } from "@filament/react/card"
import { FlexBox } from "@filament/react/layout"
import { Heading } from "@filament/react/text"

interface PageErrorProps {
    error?: Error
    reset?: () => void
}

export const PageError = ({ error }: PageErrorProps) => {
    return (
        <Card width="100%" height="100%">
            <FlexBox
                flexDirection="column"
                height="100%"
                justifyContent="center"
                alignItems="center"
                gap={0}>

                <Heading elementType="h4" variant="heading-s">
                    Page Error
                </Heading>

                <p>This page encountered an error. Please try navigating to another page.</p>

                {error && (
                    <p color="">{error.message}</p>
                )}

            </FlexBox>
        </Card>




    )
}